









































































import {Component, Vue} from "vue-property-decorator";
import axios from "axios";

import {ReservationModel} from "@/model/reservation.model";
import {ReservationUtils} from "@/reservation-utils";
import {CommonConstant} from "@/common-constant";

import Terms from "@/component/policy/terms.vue";
import PrivatePolicy from "@/component/policy/privacy-policy.vue";
import SitePolicy from "@/component/policy/site-policy.vue";
import UserInfoInput from "@/component/mypage/user-info-input.vue"
import CarInfoInput from "@/component/mypage/car-info-input.vue";

import {UserInfoForRegisterTmpModel} from "@/model/user-info/user-info-for-register-tmp.model";

import {UserInfoChecker} from "@/model/user-info/functions/user-info-input-checker";
import {UserInfoUtils} from "@/model/user-info/functions/user-info-utils";

import {CarInfoInputChecker} from "@/model/car-info/functions/car-info-input-checker"


@Component({
    components: {Terms, PrivatePolicy, SitePolicy, UserInfoInput, CarInfoInput}
})
export default class Regist extends Vue {
    /** 共通ID表示名 */
    commonIdName: string = CommonConstant.COMMON_ID_NAME;

    model: UserInfoForRegisterTmpModel = new UserInfoForRegisterTmpModel;
    reservation: ReservationModel = new ReservationModel;

    created() {

        // Apple連携ユーザの名前を取得
        UserInfoUtils.getAppleUserName((status: number, name: string) => {

            // Apple連携ユーザの場合、名前を初期入力
            if(name) {
                this.model.user.name = name;
            }

            // 入力データをセッションから削除
            sessionStorage.removeItem("regist");
            sessionStorage.removeItem("reservation");

            // セッションからクエリパラメータ値の設定。取得後削除
            // 会員
            let memberQuery = JSON.parse(sessionStorage.getItem("memberQuery"));
            if (memberQuery) {
                if(memberQuery.user.name) this.model.user.name = memberQuery.user.name;
                if(memberQuery.user.tel) this.model.user.tel = memberQuery.user.tel;
                sessionStorage.removeItem("memberQuery");
            }
            // 予約連携
            let reservationQuery = JSON.parse(sessionStorage.getItem("reservationQuery"));
            if (reservationQuery) {
                this.reservation = reservationQuery
                sessionStorage.removeItem("reservationQuery");
            }

            UserInfoUtils.getUserInfo((status: number) => {
                // 会員情報がすでに登録済みの場合
                if (status != 404) {
                    // 予約連携の場合、セッションに再度格納する。
                    if (memberQuery) {
                        sessionStorage.setItem("memberQuery", JSON.stringify(this.model));
                    }
                    if (reservationQuery) {
                        sessionStorage.setItem("reservationQuery", JSON.stringify(this.reservation));
                    }
                    // 強制ログアウトし、Auth0ログイン画面を表示する
                    axios.get("/logoutAndLogin").then(cb => {
                        window.location.href = cb.data;
                    }).catch(cb => {
                        // ステータスコード503（過負荷 or メンテナンスモード）の場合、マイページに遷移する
                        if (cb.response && cb.response.status === 503) {
                            window.location.href = "/client/mypage";
                        } else {
                            console.error(cb);
                        }
                    });
                }
                // 未登録の場合
                else {
                    // 予約ID、予約Keyが指定された場合
                    if (this.reservation.reservationId && this.reservation.reservationId != "" &&
                        this.reservation.reservationKey && this.reservation.reservationKey != ""
                    ) {
                        // 予約情報を取得
                        ReservationUtils.getReservationInfo(this.$router, this.reservation, (status: number, receiveReserv: any) => {
                            this.model.copy(receiveReserv);

                            // modelの初期化
                            this.model.initialize();
                        })
                    }
                    // 予約ID、予約Keyが指定されていない場合
                    else {
                        // modelの初期化
                        this.model.initialize();
                    }

                }
            });
        });
    }

    mounted() {
        document.getElementById("box1").style.display = "inline-grid";
    }

    /** 確認画面へ遷移 */
    routeConfirm() {
        // お客様情報の入力チェック
        const hasErrorMember: boolean = !UserInfoChecker.checkAll(this.model.user);
        
        // お車情報の入力チェック
        const hasErrorCar: boolean = !CarInfoInputChecker.checkAll(this.model.car);

        // 入力エラーがある場合は、スクロールを上部に戻し、処理を終了
        if (hasErrorMember || hasErrorCar) {
            // 会員情報のエラーなら画面最上部にスクロール
            if(hasErrorMember) {
                window.scrollTo(0, 0);
            }
            // お車情報のエラーならちょうどいい位置にスクロール
            else {
                const y = window.pageYOffset + document.getElementById('carMakerInputArea').getBoundingClientRect().top;
                window.scrollTo(0, y);
            }
        }
        // エラーが無ければ次の画面に進む
        else {
            // 前後で異なるサイズのタイヤを利用しているフラグがない場合、前タイヤサイズの値と同じ値を後タイヤに設定します。
            if (!this.model.car.showBothTireFlag) {
                this.model.car.syncFront();
            }

            // セッションにデータを設定
            sessionStorage.setItem("regist", JSON.stringify(this.model));
            sessionStorage.setItem("reservation", JSON.stringify(this.reservation));

            window.scrollTo(0, 0);
            this.$router.push("/client/regist-confirm");
        }
    }
}
